import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/option-group/option-group.js'

const tagName = 'dap-ds-option-group'

/**
 * `dap-ds-option-group`
 * @summary An option group is a container for grouping related option items.
 * Used with dap-ds-select to create grouped options that render as native optgroup elements.
 * @element dap-ds-option-group
 * @title - Option group
 *
 * @property {string} label - The label of the option group (displayed in native optgroup).
 * @property {boolean} disabled - Whether all options in the group are disabled.
 *
 * @slot - The option items in this group.
 *
 * @csspart base - The main option group container.
 * @csspart label - The label of the option group.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSOptionGroup',
})

export default reactWrapper
